import { useMutation, useQuery } from "@apollo/client";
import {
  LoadingOverlay,
  Modal,
  Drawer,
  Button,
  ScrollArea,
  useMantineTheme,
  Card,
  Group,
  Avatar,
} from "@mantine/core";
import {
  DEL_CATEGORY,
  DEL_Product_CATEGORY,
  DEL_Values,
} from "apollo/mutuations";
import { FiEdit, FiEye } from "react-icons/fi";
import EditIcon from "@mui/icons-material/Edit";
import {
  GET_CATEGORIES,
  GET_Product_CATEGORIES,
  GET_Values,
} from "apollo/queries";
import CategoryAddModal from "components/Category/categoryAddModal";
import CategoryEditModal from "components/Category/categoryEditModal";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import { useState, useEffect } from "react";
import { showNotification } from "@mantine/notifications";
import { Edit, ManualGearbox, Trash } from "tabler-icons-react";
import CategoryDetailModal from "components/Category/categoryDetail";
import Controls from "components/controls/Controls";
import { useViewportSize } from "@mantine/hooks";
import AddValueModal from "./addValue";
import EditValueModal from "./editValue";

const AttributeDetailModal = ({ id }) => {
  const { height } = useViewportSize();
  const [size, setSize] = useState("10"); // Default page size
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [hasMounted, setHasMounted] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  //
  const [openedAdd, setOpenedAdd] = useState(false);
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);

  const theme = useMantineTheme();
  const [confirmedSearch, setConfirmedSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const handleManualSearch = (searchTerm) => {
    setSearchValue(searchTerm);
  };
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };
  const { data, loading, fetchMore, refetch } = useQuery(GET_Values, {
    variables: {
      attribute_id: id,
      first: parseInt(size),
      page: activePage,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
    },
  });

  const [delValue] = useMutation(DEL_Values, {
    update(cache, { data: { deleteAttributeValue } }) {
      cache.updateQuery(
        {
          query: GET_Values,
          variables: {
            attribute_id: id,
            first: parseInt(size),
            page: activePage,
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
        (data) => {
          if (data.attributeValues.data.length === 1) {
            setTotal(total - 1);
            setActivePage(activePage - 1);
          } else {
            return {
              attributeValues: {
                data: [
                  ...data.attributeValues.data.filter(
                    (category) => category.id !== deleteAttributeValue.id
                  ),
                ],
              },
            };
          }
        }
      );
    },
  });

  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteValue = () => {
    delValue({
      variables: { id: deleteID },
      onCompleted(data) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Value Deleted Successfully",
        });
      },
      onError(error) {
        setOpenedDelete(false);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to delete attribute ",
        });
      },
    });
  };

  const handleEditCategory = (id) => {
    setEditId(id);
    setOpenedEdit(true);
  };

  useEffect(() => {
    setHasMounted(true);
  }, []);
  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.attributeValues.paginatorInfo.lastPage);
    }
  }, [data, size]);
  useEffect(() => {
    refetch();
  }, []);
  const handleChange = (currentPage) => {
    fetchMore({
      variables: {
        first: parseInt(size),
        page: currentPage,
      },
    });
    setActivePage(currentPage);
  };
  if (!hasMounted) {
    return null;
  }
  const handleManageCategory = (id) => {
    setEditId(id);
    setOpenedDetail(true);
  };
  const headerData = [
    {
      label: "#Id",
      key: "index",
      sortable: false,
      searchable: false,
      render: (rowData, rowIndex) => {
        const index = (activePage - 1) * parseInt(size) + rowIndex + 1;
        return <span>{index}</span>;
      },
    },

    {
      label: "Value",
      key: "value",
      sortable: true,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.value}</span>;
      },
    },

    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <>
            <Controls.ActionButton
              color="primary"
              title="Update"
              onClick={() => handleEditCategory(rowData)}
            >
              <EditIcon style={{ fontSize: "1rem" }} />
            </Controls.ActionButton>
            <Controls.ActionButton
              color="primary"
              title="Delete"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={17} />
            </Controls.ActionButton>
          </>
        );
      },
    },
  ];

  const optionsData = {
    actionLabel: "Add Value",
    setAddModal: setOpenedAdd,
  };
  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
      <div style={{ width: "98%", margin: "auto" }}>
        <Drawer
          opened={openedEdit}
          onClose={() => setOpenedEdit(false)}
          styles={{
            closeButton: {
              color: "black",
              marginTop: "50px",
            },
          }}
          padding="xl"
          position="right"
          size="40%"
        >
          <EditValueModal setOpened={setOpenedEdit} values={editId} />
        </Drawer>
        <Drawer
          opened={openedAdd}
          onClose={() => setOpenedAdd(false)}
          styles={{
            closeButton: {
              color: "black",
              marginTop: "50px",
            },
          }}
          padding="xl"
          position="right"
          size="40%"
        >
          <AddValueModal
            total={total}
            activePage={activePage}
            setActivePage={setActivePage}
            setOpened={setOpenedAdd}
            setTotal={setTotal}
            id={id}
            size={size}
            refetch={refetch}
          />
        </Drawer>
        <Modal
          opened={openedDelete}
          onClose={() => setOpenedDelete(false)}
          title="Warning"
          centered
        >
          <p>Are you sure do you want todelete this value?</p>
          <Group position="right">
            <Button onClick={() => deleteValue()} color="red">
              Delete
            </Button>
          </Group>
        </Modal>

        <Card shadow="sm" p="lg">
          <ScrollArea>
            <B2bTable
              total={total}
              activePage={activePage}
              clearInput={clearInput}
              handelSearch={handleManualSearch}
              searchValue={confirmedSearch}
              onSearchChange={setConfirmedSearch}
              handleChange={handleChange}
              header={headerData}
              optionsData={optionsData}
              loading={loading}
              data={data ? data.attributeValues.data : []}
              handlePageSizeChange={handlePageSizeChange}
              size={size}
            />
          </ScrollArea>
        </Card>
      </div>
    </ScrollArea>
  );
};

export default AttributeDetailModal;
